import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbcCoreDataModule } from './data/src/lib/abc-core-data.module';
import { AbcLetDirective } from './directives';
import { AbcCoreErrorHandlingModule } from './error-handling/src/lib/abc-core-error-handling.module';
import { AbcCoreLoggingModule } from './logging/src/lib/abc-core-logging.module';

@NgModule({
  imports: [CommonModule, AbcCoreDataModule, AbcCoreErrorHandlingModule, AbcCoreLoggingModule],
  declarations: [AbcLetDirective],
  exports: [AbcLetDirective],
})
export class AbcCoreModule {
  constructor() {}
}
